import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { getBottomBarTemplate } from "@/assets/utilities/tinymce/shortcodes/templates";
import { parseToHtml } from "@/utility/parseToHtml";

const editBottomBarConfig = (editor, shortcodeWrapper) => {
  let currentData = null;

  const bottomBarWindow = editor.windowManager.openUrl({
    title: "Bottom Bar",
    url: "/bottom-bar-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      editor.windowManager.alert("Success!");
      shortcodeWrapper.setAttribute("data-bottom-bar-data", currentData);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "requestData") {
        sendData();
      }

      if (message.mceAction === "updateBottomBarData") {
        currentData = message.data;
      }
    },
    width: 600,
    height: 300,
  });

  const sendData = () => {
    bottomBarWindow.sendMessage({
      type: "sendData",
      data: shortcodeWrapper.getAttribute("data-bottom-bar-data"),
    });
  };
};

const bottomBarConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Bottom Bar",
    url: "/bottom-bar-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getBottomBarTemplate(),
        "bottom-bar-shortcode",
      );
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");

      shortcodeWrapperEl.setAttribute("data-bottom-bar-data", currentData);

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width: 600,
    height: 300,
  });
};

export { bottomBarConfig, editBottomBarConfig };
